module.exports = __webpack_public_path__ + "static/media/fire-alt.11444959.svg";